import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=c3f8a45c&"
import script from "./upload-file.vue?vue&type=script&lang=js&"
export * from "./upload-file.vue?vue&type=script&lang=js&"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=c3f8a45c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports